export default "__VITE_ASSET__d0be012d__"